import {StyledIconWrapper} from './style'
import {ReactNode} from 'react'

export const IconWrapper = ({children}: {children: ReactNode}) => {
    return <StyledIconWrapper>{children}</StyledIconWrapper>
}
